/**
 * @generated SignedSource<<5ae7e1e9b434e2cb775617631d0d3be4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveInstallmentScheduled_charge$data = {
  readonly brCode: string | null | undefined;
  readonly company: {
    readonly logo: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly identifier: string | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentLinkTransactionDetails_charge">;
  readonly " $fragmentType": "PaymentActiveInstallmentScheduled_charge";
};
export type PaymentActiveInstallmentScheduled_charge$key = {
  readonly " $data"?: PaymentActiveInstallmentScheduled_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallmentScheduled_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveInstallmentScheduled_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "fitIn",
                  "value": true
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(fitIn:true)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxID",
          "kind": "LinkedField",
          "name": "taxID",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxID",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkTransactionDetails_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "2204284e37ab87c8cfc2bf84f8cacfba";

export default node;
